<br><br><br><br>
<button class="button button1" (click)="ler()">LER</button>
<!--<button class="button button2">Blue</button>-->

<div id="yourElement" name="yourElement">

</div>